import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonLibModule } from '@nrwl/common-lib';
import { CommonMaterialModule } from '@nrwl/common-material';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  Device,
  DevicesService,
  IDeviceData,
  LmapService,
  TestListService,
  TimeoutWrapperService
} from '@nrwl/common-lib';
import { ControllerApiService } from '@nrwl/test-setup';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Papa } from 'ngx-papaparse';

@Component({
  selector: 'nrwl-twamp-reflector-results',
  standalone: true,
  imports: [CommonModule, CommonMaterialModule, CommonLibModule, FormsModule, ReactiveFormsModule],
  templateUrl: './twamp-reflector-results.component.html',
  styleUrls: ['./twamp-reflector-results.component.scss']
})
export class TwampReflectorResultsComponent implements OnInit, OnDestroy {
  @ViewChild('reflectorForm', { static: true }) form: NgForm;

  deviceData: IDeviceData;
  testName: string;
  activity: any;
  agentModel: string;
  raiseConfirm = false;
  monitorStarted = false;
  holdingPattern = false; //true when waiting for confirmation test really got started without any errors
  actionMsg = null;
  errorMsg = null;
  errorIcon = 'warning';
  testNameisValid = true;
  isLoading = false;
  mgmtPortTesting = false;
  viewTestObj: any = {};
  newTestObj: any = {};
  formObj: any = {};
  isAllowPersist = false;
  liteModeSelect = false;
  ipVersionEnabled = true;
  isNewTestConfig = false;
  isnotUniqueConfig = false;
  selectedIpVersion = 'v4';
  activeTabID = null;
  allActiveTestList = [];
  activeTestlist = [];
  savedTestConfigs = [];
  removeConfirm = false;
  testConfigs = [];
  maxConcurrentTestCount = 0;
  isExceedMaxTest = false;
  isnotUniqueIPConfig = false;
  selctedTestID = null;
  selectedTestInfo = null;
  reflectorModeName = null;
  schedName: string;
  activeSessions = '---';
  activeFlows = '---';
  packetsReflected = '---';
  sessionsConfig = {
    maxFlows: '5',
    maxSessions: '5'
  };
  flowsConfig = {
    maxFlows: '50'
  };
  defaultConfig = {
    instanceName: null,
    ipAddress: '192.168.2.10',
    subnet: '255.255.255.0',
    gateway: '192.168.2.1',
    ipAddressV6: 'fc00::10',
    prefixV6: '64',
    gatewayV6: 'fc00::1',
    ipVersion: 'v4',
    port: '862',
    maxSessions: '5',
    udpport: '50000',
    maxFlows: '50',
    reflectorMode: 'full',
    liteModeSelect: false,
    vlanNumber: 'untagged',
    etherType: '88a8'
  };
  singleReflector = false;
  badIpValues = ['', '0.0.0.0', '255.255.255.255', '::/0'];
  showJMEPConfig = true;
  reflectorLmapConfig = null;
  controlPortPattern =
    /^([1-9]|[1-9]\d{1,3}|[1-5]\d{4}|6[0-4]\d{3}|65[0-4]\d{2}|655[0-2]\d|6553[0-5])$/;
  vLanPattern = /^([1-9]|[1-9]\d{1,2}|[1-3]\d{3}|40[0-8]\d|409[0-5])$/;
  vLanPriorityPattern = /^([0-7]?)$/;
  vLanPriority = '0';
  ipv6PrefixLengthPattern = /^([1-9][0-9]?|1[01][0-9]|12[0-8])$/;
  ipv4SubnetPattern =
    /^(((255\.){3}(255|254|252|248|240|224|192|128|0+))|((255\.){2}(255|254|252|248|240|224|192|128|0+)\.0)|((255\.)(255|254|252|248|240|224|192|128|0+)(\.0+){2})|((255|254|252|248|240|224|192|128|0+)(\.0+){3}))$/;
  ipv4Pattern =
    /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
  ipv6Pattern =
    /^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$/;
  private readonly unsubscribe: Subject<void> = new Subject();
  private timeoutPromise = {};
  private pollingInterval = 4000;
  constructor(
    private readonly controllerApiService: ControllerApiService,
    private readonly lmap: LmapService,
    private readonly timeout: TimeoutWrapperService,
    private readonly testListService: TestListService,
    private readonly deviceService: DevicesService,
    private papa: Papa,
    @Inject(MAT_DIALOG_DATA)
    public data: { deviceObj: Device; selectedTestID: string; testName: string; testType: string }
  ) {}

  ngOnInit(): void {
    this.deviceData = this.data.deviceObj.deviceData;
    this.selctedTestID = this.data.selectedTestID;
    this.testName = this.data.testName;
    this.agentModel = this.data.deviceObj.getModel();
    if (this.agentModel?.includes('JMEP')) {
      this.showJMEPConfig = true;
      this.formObj.ipAddress = this.getJMEPIpAddress();
      this.formObj.vlan =
        this.deviceData.capabilities.phy['test-vlan-id'] &&
        this.deviceData.capabilities.phy['test-vlan-id'] !== '-1'
          ? this.deviceData.capabilities.phy['test-vlan-id']
          : null;
      this.formObj.udpport = this.deviceData.capabilities.simpleTestConfig['twamp-udp-port']
        ? this.deviceData.capabilities.simpleTestConfig['twamp-udp-port']
        : this.defaultConfig.udpport;
    } else {
      this.showJMEPConfig = false;
      this.activity = this.deviceData.phyId
        ? this.deviceData.activity[this.deviceData.phyId]
        : this.deviceData.activity;
      this.getDeviceCapabilities();
      this.activeTestlist = this.getActiveTestlist();
      this.newTestObj = { ...this.defaultConfig };
      this.reflectorModeName = this.data.testType;
      this.getActiveTestConfigs(this.selctedTestID);
    }
  }

  ngOnDestroy(): void {
    if (this.timeoutPromise) {
      Object.keys(this.timeoutPromise).forEach((key, index) => {
        this.timeout.cancel(key);
      });
    }
    if (this.timeoutPromise[this.selctedTestID]) {
      this.timeout.cancel(this.timeoutPromise[this.selctedTestID]);
    }
    this.stopTestStatusPoll(this.selctedTestID);
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
  getDeviceCapabilities(): void {
    //Enable IpV6 based on capability
    if (this.deviceData) {
      //Ipv6 control
      let cap;
      if (this.deviceData.capabilities.diagnostics) {
        const index = this.agentModel.indexOf('vPMA');
        if (this.deviceData.capabilities.diagnostics['reboot-allowed'] === 'true' && index != -1) {
          this.isAllowPersist = true;
        } else {
          this.isAllowPersist = false;
        }
      }
      const testPortPhyId = this.deviceData['phyId'];
      if (testPortPhyId) {
        //For QT
        const selList = this.liteModeSelect ? 'twamp-light-reflector-list' : 'twamp-reflector-list';
        const capList = this.deviceData.capabilities[selList];
        for (const key in capList) {
          if (testPortPhyId === capList[key]['phy-id']) {
            cap = capList[key];
            break;
          }
        }
      } else {
        //vPMA
        cap = this.deviceData.capabilities['twamp-reflector'];
        // if (this.liteModeSelect) {
        //     cap = this.ep.extension.capabilities['twamp-light-reflector'];
        // }
      }

      if (cap) {
        if (this.agentModel === 'QT600-10') {
          this.ipVersionEnabled = true;

          // MV-2567 if QT600-10 then max flows and sessions are not configurable. Show what is set in
          // capabilities and disable the field
          this.defaultConfig.maxSessions =
            cap['max-control-sessions-per-test'] || this.defaultConfig.maxSessions;
          this.defaultConfig.maxFlows = cap['max-flows-per-test'] || this.defaultConfig.maxFlows;
        } else {
          this.ipVersionEnabled = 'true' === cap.ipv6;
        }
        this.maxConcurrentTestCount = cap['max-concurrent-tests'];
        this.flowsConfig.maxFlows = cap['max-flows-per-test'];
        this.sessionsConfig.maxSessions = cap['max-control-sessions-per-test'];
      }
    }

    if (
      this.agentModel.indexOf('vPMA') >= 0 &&
      this.deviceData.capabilities.system['management-port-testing'] === 'true' &&
      this.deviceData.mgmtIPaddress
    ) {
      this.mgmtPortTesting = true;
      if (this.ipv4Pattern.test(this.deviceData.mgmtIPaddress)) {
        this.newTestObj.ipVersion = 'v4';
        this.newTestObj.ipAddress = this.deviceData.mgmtIPaddress;
      } else {
        this.newTestObj.ipVersion = 'v6';
        this.newTestObj.ipAddressV6 = this.deviceData.mgmtIPaddress;
      }
    }
  }

  getActiveTestConfigs(testId: number): void {
    this.activeSessions = '---';
    this.activeFlows = '---';
    this.packetsReflected = '---';
    // Check reflector mode: Standard or Lite mode
    if (this.reflectorModeName === 'twamp-reflector') {
      this.viewTestObj.reflectorMode = 'full';
      this.viewTestObj.liteModeSelect = false;
    } else if (this.reflectorModeName === 'twamp-light-reflector') {
      this.viewTestObj.liteModeSelect = true;
      this.viewTestObj.reflectorMode = 'light';
    }

    this.isLoading = true;
    // get our config from the controller because this config is exactly what started the reflector.
    this.controllerApiService
      .getTestConfig(testId, true)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        response => {
          if (response.status === 'success') {
            this.reflectorLmapConfig = response.data.config;
            this.updateInstanceName(testId, response);
            const config = this.lmap.getTestOptions(
              this.reflectorModeName,
              [
                'source-ip',
                'subnet',
                'prefix-length',
                'gateway',
                'reflector-udp-port',
                'max-connections',
                'max-flows',
                'twamp',
                'vlan-id',
                'vlan-priority',
                'inner-vlan-id',
                'inner-vlan-priority',
                'tpid',
                'persist'
              ],
              response.data.config
            );
            this.viewTestObj.ipAddress = config['source-ip'];
            this.viewTestObj.subnet = config.subnet;
            this.viewTestObj.gateway = config.gateway;
            if (this.agentModel.indexOf('vPMA') != -1) {
              this.viewTestObj.vlanId = '';
              this.viewTestObj.sVlanId = config['vlan-id'] || '';
              this.viewTestObj.cVlan = config['inner-vlan-id'] || '';
              this.viewTestObj.cVlanPriority = config['inner-vlan-priority'] || 0;
            } else {
              this.viewTestObj.vlanId = config['vlan-id'] || '';
            }
            this.viewTestObj.vLanPriority = config['vlan-priority'] || '0';
            this.viewTestObj.enableVlan = !!this.viewTestObj.vlanId;
            let configVlan = 'untagged';
            if (this.viewTestObj.sVlanId && this.viewTestObj.cVlan) {
              configVlan = 'q_in_q';
            } else if (this.viewTestObj.sVlanId) {
              configVlan = 'tagged';
            }
            this.viewTestObj.etherType = config['tpid'] || this.defaultConfig.etherType;
            this.viewTestObj.vlanNumber = configVlan;
            this.viewTestObj.ipVersion = 'v4';
            let persistEnabled = config['persist'];
            if (typeof persistEnabled === 'string') {
              persistEnabled = persistEnabled === 'true' ? true : false;
            }
            this.viewTestObj.restartOnBoot = persistEnabled;
            if (config['prefix-length']) {
              //ipv6 load config
              this.viewTestObj.ipAddressV6 = this.viewTestObj.ipAddress;
              this.viewTestObj.gatewayV6 = this.viewTestObj.gateway;
              this.viewTestObj.prefixV6 = config['prefix-length'];
              this.viewTestObj.ipVersion = 'v6';
            } else {
              this.viewTestObj.ipAddressV6 = this.defaultConfig.ipAddressV6;
              this.viewTestObj.gatewayV6 = this.defaultConfig.gatewayV6;
              this.viewTestObj.prefixV6 = this.defaultConfig.prefixV6;
            }

            this.viewTestObj.maxSessions =
              config['max-connections'] || this.defaultConfig.maxSessions;
            this.viewTestObj.maxFlows = config['max-flows'] || this.defaultConfig.maxFlows;
            this.viewTestObj.udpport = config['reflector-udp-port'] || this.defaultConfig.udpport;
            try {
              const twampObj = JSON.parse(config.twamp);
              this.viewTestObj.port =
                twampObj['ietf-twamp:twamp']['twamp-server']['server-tcp-port'];
              this.viewTestObj.maxSessions =
                config['max-connections'] ||
                twampObj['ietf-twamp:twamp']['twamp-server']['max-connections'] ||
                this.defaultConfig.maxSessions;
              this.viewTestObj.maxFlows =
                config['max-flows'] ||
                twampObj['ietf-twamp:twamp']['twamp-server']['max-flows'] ||
                this.defaultConfig.maxFlows;
            } catch (err) {
              //eslint-disable-next-line
              console.log('twamp-reflect-ctrl:init: JSON parse failed: ' + JSON.stringify(err));
            }
            this.viewTestObj.port = this.viewTestObj.port || this.defaultConfig.port;
            this.isLoading = false;
            this.formObj = { ...this.viewTestObj };
          } else {
            this.isLoading = false;
          }
        },
        () => {
          this.isLoading = false;
        }
      );

    // startup test status polling
    this.timeoutPromise[this.selctedTestID] = this.timeout.set(
      'reflector-' + this.selctedTestID,
      () => {
        this.startPollingTestStatus(this.selctedTestID);
      },
      100
    );
  }

  startPollingTestStatus(testId: string): void {
    if (this.timeoutPromise[testId]) {
      this.timeout.cancel(this.timeoutPromise[testId]);
    }
    this.testListService
      .getTestStatus(testId)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        response => {
          this.handleTestStatusResponse(response);
        },
        response => {
          this.stopTestStatusPoll(testId);
          this.setErrorMessage(response.message);
        }
      );
  }

  getTestNamefromList(testID: string): string {
    const objIndex = this.activeTestlist.findIndex(obj => obj.id == testID);
    return this.activeTestlist[objIndex].instanceName;
  }

  getActiveTestlist(): any {
    const runningTest = this.activity.tests;
    let activeTests = [];
    if (this.activity) {
      if (this.activity.status === 'running') {
        if (runningTest) {
          if (runningTest['twamp-reflector']) {
            activeTests = runningTest['twamp-reflector'];
            activeTests.map(test => {
              test.type = 'twamp-reflector';
              test.status = 'running';
            });
          }
          if (runningTest['twamp-light-reflector']) {
            const lightReflector = runningTest['twamp-light-reflector'];
            if (lightReflector) {
              lightReflector.map(test => {
                test.type = 'twamp-light-reflector';
                test.status = 'running';
              });
            }
            if (activeTests) {
              activeTests = activeTests.concat(lightReflector);
            } else {
              activeTests = lightReflector;
            }
          }
        }
      }
    }
    const selecteTestObj = activeTests.find(test => test.id === this.selctedTestID);
    this.activeTabID = this.selctedTestID;
    this.selectedTestInfo = selecteTestObj;
    return activeTests;
  }

  // eslint-disable-next-line
  stopTestStatusPoll(scheduleId): void {
    if (this.timeoutPromise[scheduleId]) {
      this.timeout.cancel(this.timeoutPromise[scheduleId]);
    }
  }

  //eslint-disable-next-line
  generateInstanceName(testnameSufix): string {
    const sufixval = parseInt(testnameSufix + 1);
    let testName = 'Reflector-' + sufixval;
    const isExisting = this.activeTestlist.some(el => {
      return el.instanceName == testName;
    });
    if (isExisting) {
      testName = this.generateInstanceName(sufixval);
    }
    return testName;
  }

  validateInstanceName(): void {
    // validate the Instance Name is
    this.testNameisValid = true;
    if (this.isNewTestConfig && this.activeTestlist.length > 0) {
      let found = false;
      if (this.activeTabID) {
        found = this.activeTestlist.some(
          el =>
            el.instanceName.toLowerCase() === this.formObj.instanceName.toLowerCase() &&
            el.id !== this.activeTabID
        );
      } else {
        found = this.activeTestlist.some(
          el => el.instanceName.toLowerCase() === this.formObj.instanceName.toLowerCase()
        );
      }
      if (found) {
        this.testNameisValid = false;
      } else {
        this.testNameisValid = true;
      }
    }
  }

  reflectorVersionValid(): boolean {
    // Check the version of reflector, lite mode only supported on version >= 2.0
    if (
      this.data.deviceObj.getVersion()?.value &&
      !(this.data.deviceObj.getVersion().value.indexOf('1.0') === 0)
    ) {
      return true;
    } else {
      return false;
    }
  }

  checkModeType(): void {
    if (this.formObj.reflectorMode == 'full') {
      this.formObj.reflectorMode = 'light';
    } else {
      this.formObj.reflectorMode = 'full';
    }
  }

  isUniqueConfig(): void {
    if (this.isNewTestConfig) {
      if (this.testConfigs && this.testConfigs.length > 0) {
        const currentConfig = [];
        currentConfig['ipAddress'] =
          this.formObj.ipVersion === 'v4' ? this.formObj.ipAddress : this.formObj.ipAddressV6;
        let vlanNumber = this.formObj.vlanNumber;
        if (this.agentModel.indexOf('vPMA') != -1) {
          if (vlanNumber !== 'untagged') {
            currentConfig['vlanId'] = this.formObj.sVlanId;
            if (vlanNumber === 'q_in_q') {
              currentConfig['cVlan'] = this.formObj.cVlan;
            }
          }
        } else {
          vlanNumber = 'QTConfig';
          currentConfig['vlanId'] = this.formObj.vlanId;
        }
        const isExistingConfig = this.testConfigs.find(
          el => el['source-ip'] === currentConfig['ipAddress']
        );
        if (isExistingConfig) {
          if (vlanNumber === 'untagged') {
            if (isExistingConfig['source-ip'] === currentConfig['ipAddress']) {
              this.isnotUniqueIPConfig = true;
            } else {
              this.isnotUniqueIPConfig = false;
            }
          } else if (vlanNumber === 'tagged' || vlanNumber === 'QTConfig') {
            if (
              isExistingConfig['source-ip'] === currentConfig['ipAddress'] &&
              isExistingConfig['vlan-id'] === currentConfig['vlanId']
            ) {
              this.isnotUniqueConfig = true;
              this.isnotUniqueIPConfig = true;
            } else {
              this.isnotUniqueConfig = false;
              this.isnotUniqueIPConfig = false;
            }
          } else if (vlanNumber === 'q_in_q') {
            if (
              isExistingConfig['source-ip'] === currentConfig['ipAddress'] &&
              isExistingConfig['vlan-id'] === currentConfig['vlanId'] &&
              isExistingConfig['inner-vlan-id'] === currentConfig['cVlan']
            ) {
              this.isnotUniqueConfig = true;
              this.isnotUniqueIPConfig = true;
            } else {
              this.isnotUniqueConfig = false;
              this.isnotUniqueIPConfig = false;
            }
          }
        } else {
          this.isnotUniqueIPConfig = false;
          this.isnotUniqueConfig = false;
        }
      }
    }
  }

  //eslint-disable-next-line
  updateInstanceName(testID, response) {
    let testName = null;
    if (response.status === 'success') {
      if (response.data.config.test && response.data.config.test['test-list-data']) {
        testName = response.data.config.test['test-list-data'].instanceName;
        if (testID && testName) {
          const objIndex = this.activeTestlist.findIndex(obj => obj.id == testID);
          this.activeTestlist[objIndex].instanceName = testName;
          // remove any entry in the list that matched the name but not the testID -- old entry
          this.activeTestlist = this.activeTestlist.filter(
            tst => tst.id === testID || tst.instanceName !== testName
          );
        }
      } else {
        if (testID) {
          const objIndex = this.activeTestlist.findIndex(obj => obj.id == testID);
          const testObj = this.activeTestlist[objIndex];
          if (testObj && !testObj.instanceName) {
            const listCnt = this.activeTestlist.length - 1 || 0;
            testName = this.generateInstanceName(listCnt);
            this.activeTestlist[objIndex].instanceName = testName;
          }
        }
      }
    }
  }

  //eslint-disable-next-line
  onChangeVersion(ipVersion): void {
    this.selectedIpVersion = ipVersion;
  }

  //eslint-disable-next-line
  handleTestStatusResponse(response: any): void {
    const stopStates = ['finished', 'cancelled', 'timeout', 'lost', 'aborted', '45', '13'];
    if (stopStates.indexOf(response.status) >= 0) {
      // this reflector is done, end the poll let the user know
      if (response.id) {
        this.stopTestStatusPoll(response.id);
      }

      if (response.status === 'finished') {
        this.displayStopStatus({ status: 'success' });
      } else {
        // make 'UI Comm looking' error
        this.displayStopStatus({ status: 'error', data: { message: response.message } });
      }
      this.deviceService.getReflectorDevices();
    } else {
      const statusResp = response;
      let msg = null;
      if (typeof statusResp.message === 'string') {
        // see if it is a json object
        try {
          msg = JSON.parse(statusResp.message);
        } catch (err) {
          //console.log('TWAMP Reflector status message is not JSON: ' + err.message);
        }
      }

      if (
        this.holdingPattern === true &&
        ((statusResp.message && statusResp.message === 'test running') ||
          (msg && (msg['TWAMP Reflector test'] || msg['testPort'] === 'Configured')))
      ) {
        // not really looking for anything special, once any JSON data is returned the test should be up
        // Failure to start due to source IP already in use will result in no JSON data
        this.holdingPattern = false;
        this.deviceService.getReflectorDevices();
        this.setSuccessMessage('Reflector is running');
      }
      // Current Session Count
      if (msg && msg['Number of Connections']) {
        this.activeSessions = this.addCommas(msg['Number of Connections']);
      } else {
        this.activeSessions = '---';
      }
      // Current Flow Count
      if (msg && msg['Number of Sessions']) {
        this.activeFlows = this.addCommas(msg['Number of Sessions']);
      } else {
        this.activeFlows = '---';
      }
      // Reflected Packets
      if (msg && msg['Reflected Packets']) {
        this.packetsReflected = this.addCommas(msg['Reflected Packets']);
      } else {
        this.packetsReflected = '---';
      }
      this.timeoutPromise[response.id] = this.timeout.set(
        'reflector-' + response.id,
        () => {
          this.startPollingTestStatus(response.id);
        },
        this.pollingInterval
      );
    }
  }

  //eslint-disable-next-line
  addCommas(num): any {
    let mynum = num;
    if (typeof mynum !== 'string') {
      mynum = num.toString();
    }
    return mynum.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  reflectorTypeValid(): boolean {
    if (
      this.agentModel === 'vPMA' ||
      this.agentModel === 'vPMA-L' ||
      this.agentModel === 'QT600-10'
    ) {
      return true;
    } else {
      return false;
    }
  }

  // Only called when the test successfully stopped or the test itself
  // told us it is not running anymore.
  // Failure to get a valid status response (response.status from UIComm != success) should not call this.
  //eslint-disable-next-line
  displayStopStatus(response: any): void {
    if (response.status === 'success') {
      if (this.selctedTestID) {
        this.stopTestStatusPoll(this.selctedTestID);
      }
      this.setSuccessMessage('Reflector is no longer running');
      this.deviceService.getReflectorDevices();
    } else {
      this.setErrorMessage(response.data.message);
    }
    this.activity.status = 'idle';
    this.activity.message = 'ready';
  }

  isExceedsMaxlimit(): boolean {
    const reflectorRunningTest = this.activeTestlist.filter(obj => {
      return obj.status === 'running';
    });
    const maxTestCount = Number(this.maxConcurrentTestCount);
    let otherTests = 0;
    if (this.activity.tests) {
      Object.keys(this.activity.tests).forEach(key => {
        if (key !== 'twamp-reflector' && key !== 'twamp-light-reflector') {
          otherTests = otherTests + this.activity.tests[key].length;
        }
      });
    }
    const testCount = reflectorRunningTest.length + otherTests;
    if (Number(maxTestCount) <= Number(testCount)) {
      if (this.agentModel === 'QT600-10') {
        if (
          reflectorRunningTest &&
          reflectorRunningTest[0] &&
          reflectorRunningTest[0].status === 'running'
        ) {
          this.isExceedMaxTest = true;
        } else {
          this.isExceedMaxTest = false;
        }
      } else {
        this.isExceedMaxTest = true;
      }
    }
    return this.isExceedMaxTest;
  }

  setErrorMessage(message: string): void {
    if (message) {
      message = message.replace('$$20110$$', ''); //remove error code holder
    }
    this.actionMsg = null;
    this.errorIcon = 'warning';
    this.errorMsg = message;
    setTimeout(() => {
      this.errorMsg = null;
    }, 3000);
  }

  setSuccessMessage(message: string): void {
    this.actionMsg = null;
    this.errorIcon = 'check_circle';
    this.errorMsg = message;
    setTimeout(() => {
      this.errorMsg = null;
    }, 3000);
  }

  okClicked(): void {
    this.actionMsg = null;
    this.errorMsg = null;
  }

  // handle reflector light port range check
  // port range 1-65535, except for 5060
  //
  handleReflectorLightPortRange(): void {
    if (
      this.formObj.udpport >= 1 &&
      this.formObj.udpport <= 65535 &&
      this.formObj.udpport != 5060
    ) {
      this.form.controls.udpport.setErrors(null);
    } else {
      this.form.controls.udpport.setErrors({ regex: 'wrong' });
    }
  }

  //eslint-disable-next-line
  getTestType(testID): any {
    const objIndex = this.allActiveTestList.findIndex(obj => obj.id == testID);
    return this.allActiveTestList[objIndex].type;
  }

  isEditable(): boolean {
    let isEditable = true;
    if (!this.isNewTestConfig && (this.actionMsg || this.selctedTestID)) {
      isEditable = false;
    }
    return isEditable;
  }

  getJMEPIpAddress(): string {
    let ipAddress = '';
    const testIP = this.deviceData.capabilities.phy['test-ip']
      ? this.deviceData.capabilities.phy['test-ip']
      : null;
    const mgmtIP = this.deviceData.capabilities.phy['assigned-ip']
      ? this.deviceData.capabilities.phy['assigned-ip']
      : null;
    if (testIP && !this.badIpValues.includes(testIP)) {
      ipAddress = testIP;
    } else if (mgmtIP && !this.badIpValues.includes(mgmtIP)) {
      ipAddress = mgmtIP;
    }
    return ipAddress;
  }

  isDiableBtn(): boolean {
    let butnDisable = false;
    if (
      this.isNewTestConfig &&
      (!this.testNameisValid || this.isnotUniqueConfig || this.isnotUniqueIPConfig)
    ) {
      butnDisable = true;
    }
    return butnDisable;
  }

  exportReflectorTestConfig(): void {
    if (this.reflectorLmapConfig) {
      let testName = 'reflectorTestConfig';
      let testPointName = '';
      let fullReflector = null;
      let lightReflector = null;
      const primaryAgentInfo = this.lmap.getAgentInfo('primary', this.reflectorLmapConfig);
      if (primaryAgentInfo) {
        testPointName = primaryAgentInfo.id;
        const lmapConfig = this.lmap.getMATestConfigByName(
          this.reflectorLmapConfig,
          primaryAgentInfo.config
        );
        if (lmapConfig) {
          lightReflector = this.lmap.extractScheduleByTaskName(lmapConfig, 'twamp-light-reflector');
          if (lightReflector) {
            testName = lightReflector?.name;
          } else {
            fullReflector = this.lmap.extractScheduleByTaskName(lmapConfig, 'twamp-reflector');
            if (fullReflector) {
              testName = fullReflector?.name;
            }
          }
        }
      }
      const testConfig = this.lmap.getTestOptions(
        this.reflectorModeName,
        [
          'source-ip',
          'subnet',
          'prefix-length',
          'gateway',
          'reflector-udp-port',
          'max-connections',
          'max-flows',
          'twamp',
          'vlan-id',
          'vlan-priority',
          'inner-vlan-id',
          'inner-vlan-priority',
          'tpid',
          'persist',
          'phy-id'
        ],
        this.reflectorLmapConfig
      );
      const reflectorConfig = [];
      const reflectorObj = {};
      reflectorObj['T/TEST'] = 'T';
      reflectorObj['TEST NAME'] = testName;
      reflectorObj['MA NAME'] = testPointName;
      reflectorObj['IP ADDRESS'] = testConfig['source-ip'];
      reflectorObj['GATEWAY'] = testConfig['gateway'];
      reflectorObj['MASK'] = testConfig['subnet'];
      reflectorObj['VLAN'] = testConfig['vlan-id'] || 0;
      reflectorObj['VLAN PRIORITY'] = testConfig['vlan-priority'] || 0;
      reflectorObj['CVLAN'] = testConfig['inner-vlan-id'] || 0;
      reflectorObj['CVLAN PRIORITY'] = testConfig['inner-vlan-priority'] || 0;
      reflectorObj['TPID'] = testConfig['tpid'];
      reflectorObj['REFLECTOR UDP PORT'] = testConfig['reflector-udp-port'];
      reflectorObj['CONTROL TCP PORT'] = testConfig['reflector-udp-port'];
      reflectorObj['MAX SESSIONS'] = testConfig['max-connections'];
      reflectorObj['MAX FLOWS'] = testConfig['max-flows'];
      reflectorObj['PERSIST'] = testConfig['persist'] === true ? 'YES' : 'NO';
      reflectorObj['TWAMP LIGHT'] = lightReflector ? 'YES' : 'NO';
      reflectorObj['QT PORT'] = testConfig['phy-id']
        ? testConfig['phy-id']?.toLowerCase() == 'p1'
          ? '1'
          : '2'
        : '0';
      reflectorObj['PREFIX LENGTH'] = testConfig['prefix-length'];
      reflectorConfig.push(reflectorObj);

      const exportData = this.papa.unparse(reflectorConfig, { header: true });
      const blob = new Blob([exportData], { type: 'text/csv;charset=utf-8;' });
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = testName + '.csv';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  }
}
